import React, { useRef, useState } from 'react';
import { Button, Toast } from 'primereact';
import { InputNumber } from 'primereact/inputnumber';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { Badge } from 'primereact/badge';
// import { Button } from 'primereact/button';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const SettingsComponent = () => {
    const [intervalSeconds, setIntervalSeconds] = useState(600);
    
    // Convert seconds to minutes for display
    const intervalMinutes = intervalSeconds / 60;
    const toast = useRef(null);

    const header = (
        <div className="flex flex-column align-items-center">
            <i className="pi pi-cog text-2xl text-blue-500 mb-3 mt-4" style={{ fontSize: '1rem' }}></i>
            <span className="text-xl font-bold text-gray-800 mb-2">CPB ONE API Settings</span>
        </div>
    );

    const showToast = (severity, summary, detail) => {
        toast.current.show({ severity, summary, detail });
    };

    const [disabledSave, setDisabledSave] = useState(false);
    const [disabledPublish, setDisabledPublish] = useState(false);

    const footer = (
        <div className="flex justify-content-end gap-2">
            {/* <Button label="Cancel" icon="pi pi-times" disabled className="p-button-outlined p-button-secondary" /> */}
            <Button label={disabledSave ? 'Saving...' : 'Save Changes'} icon="pi pi-check"
                disabled={disabledSave}
                loading={disabledSave}
                onClick={() => {
                setDisabledSave(true);
                setTimeout(() => {
                    setDisabledSave(false);
                    showToast('success', 'Success', 'Changes saved successfully.')
                }, 2000);
            }}
            className="p-button-primary primary-button" />
        </div>
    );
    
    const footerHome = (
        <div className="flex justify-content-end gap-2">
            {/* <Button label="Cancel" icon="pi pi-times" disabled className="p-button-outlined p-button-secondary" /> */}
            <Button label={disabledPublish ? 'Publishing...' : 'Publish home'} icon="pi pi-check"
                disabled={disabledPublish}
                loading={disabledPublish}
                onClick={() => {
                setDisabledPublish(true);
                setTimeout(() => {
                    setDisabledPublish(false);
                    showToast('success', 'Success', 'Changes saved successfully.')
                }, 2000);
            }}
            className="p-button-primary primary-button" />
        </div>
    );

    return (
        <div className="flex bg-gray-100 p-1 gap-4">
            <Toast ref={toast} />
            <Card header={header} footer={footer} className="w-full md:w-6 lg:w-4 shadow-5">
                <div className="text-center mb-3">
                    <p className="text-gray-600 mb-4">
                        Configure the consultation interval for CPB ONE API. 
                        <br />
                        <br />
                        Changes will affect how frequently the system request the API.
                    </p>
                    
                    <div className="field mb-4">
                        <label htmlFor="interval" className="block text-gray-700 font-semibold mb-2">
                            Consultation Interval (seconds)
                        </label>
                        <InputNumber
                            inputId="interval"
                            value={intervalSeconds}
                            onValueChange={(e) => setIntervalSeconds(e.value)}
                            mode="decimal"
                            showButtons
                            step={60}
                            min={60}
                            max={3600}
                            disabled={disabledSave}
                            // disabled
                            className="w-full"
                        />
                        <small className="text-gray-500">Value must be between 60 and 3600 seconds</small>
                    </div>
                    
                    <Divider align="center">
                        <span className="text-gray-500">Equivalent to</span>
                    </Divider>
                    
                    <div className="bg-blue-50 p-3 border-round mb-4">
                        <div className="text-blue-700 font-medium mb-1">Interval in minutes</div>
                        <div className="flex align-items-center justify-content-center">
                            <span className="text-3xl font-bold text-blue-800">{intervalMinutes}</span>
                            <span className="text-blue-700 ml-2">minutes</span>
                            <Badge value="Fixed" severity="info" className="ml-3"></Badge>
                        </div>
                    </div>
                    
                    <div className="bg-gray-100 p-3 border-round text-left">
                        <div className="flex align-items-center mb-2">
                            <i className="pi pi-info-circle text-blue-500 mr-2"></i>
                            <span className="font-semibold">Note</span>
                        </div>
                        <p className="text-gray-600 m-0 text-sm">
                            This setting is currently not in full effect.
                            <br />
                            <br />
                            Please contact our BorderGartia Engineering team to modify the consultation interval.
                        </p>
                    </div>
                </div>
            </Card>
            <Card header={
                <div className="flex flex-column align-items-center">
                    <i className="pi pi-save text-2xl text-blue-500 mb-3 mt-4" style={{ fontSize: '1rem' }}></i>
                    <span className="text-xl font-bold text-gray-800 mb-2">Revalidate home page</span>
                </div>

            } footer={footerHome} className="w-full md:w-6 lg:w-4 shadow-5">
                <div className="text-center mb-3">
                    <p className="text-gray-600 mb-4">
                        Revalidate the home page to apply changes made to entry pages.
                        <br />
                        <br />
                        Changes will affect how frequently the system request the API.
                    </p>
{/*                     
                    <div className="bg-gray-100 p-3 border-round text-left">
                        <div className="flex mb-2">
                            <i className="pi pi-info-circle text-blue-500 mr-2"></i>
                            <span className="font-semibold">Note</span>
                        </div>
                        <p className="text-gray-600 m-0 text-sm">
                            This setting is currently not in full effect.
                            <br />
                            <br />
                            Please contact our BorderGartia Engineering team to modify the consultation interval.
                        </p>
                    </div> */}
                </div>
            </Card>
        </div>
    );
};

export default SettingsComponent;